import { FormikProps } from "formik"
import { Component } from "react"
import { TrackingProp } from "react-tracking"
import { AuthenticationModal } from "Components/Authentication/Components/AuthenticationModal"
import { FormSwitcher } from "Components/Authentication/FormSwitcher"
import { handleSubmit as defaultHandleSubmit } from "Components/Authentication/helpers"
import {
  InputValues,
  ModalOptions,
  ModalType,
  SubmitHandler,
} from "Components/Authentication/Types"
import { EnableRecaptcha } from "Utils/EnableRecaptcha"

export interface ModalManagerProps {
  blurContainerSelector?: string
  csrf?: string
  handleSubmit?: (
    type: ModalType,
    options: ModalOptions,
    values: InputValues,
    formikBag: FormikProps<InputValues>
  ) => void
  image?: string
  onModalClose?: () => void
  onModalOpen?: () => void
  onSocialAuthEvent?: (options) => void
  redirectTo?: string
  showRecaptchaDisclaimer?: boolean
  submitUrls?: { [P in ModalType]: string } & {
    apple: string
    facebook: string
    google: string
    forgot?: string
  }
  tracking?: TrackingProp
  type?: ModalType
}

export interface ModalManagerState {
  currentType?: ModalType
  error?: string
  options?: ModalOptions
  recaptchaLoaded: boolean
  switchedForms: boolean
}

export class ModalManager extends Component<
  ModalManagerProps,
  ModalManagerState
> {
  state: ModalManagerState = {
    // @ts-expect-error PLEASE_FIX_ME_STRICT_NULL_CHECK_MIGRATION
    currentType: null,
    options: {} as ModalOptions,
    recaptchaLoaded: false,
    switchedForms: false,
  }

  openModal = (options: ModalOptions) => {
    const { mode } = options

    this.setState({
      currentType: mode,
      options,
      recaptchaLoaded: true,
    })

    document.body.style.overflowY = "hidden"
    this.props.onModalOpen && this.props.onModalOpen()
  }

  closeModal = () => {
    this.setState({
      // @ts-expect-error PLEASE_FIX_ME_STRICT_NULL_CHECK_MIGRATION
      currentType: null,
      options: {} as ModalOptions,
    })

    document.body.style.overflowY = "auto"
    this.props.onModalClose?.()
  }

  handleTypeChange = type => {
    const newOptions = {
      ...this.state.options,
      mode: type,
    }

    this.setState({
      currentType: type,
      options: newOptions,
      switchedForms: true,
    })
  }

  setError = err => this.setState({ error: err })

  getSubtitle = () => {
    const { options, switchedForms, currentType } = this.state

    if (switchedForms) {
      switch (currentType) {
        case ModalType.login:
          return "Log in"
        case ModalType.signup:
          return "Sign up"
        case ModalType.forgot:
          return "Reset your password"
        default:
          return "The art world online"
      }
    } else {
      return (options && options.copy) || "The art world online"
    }
  }

  render() {
    const { blurContainerSelector, csrf, submitUrls, redirectTo } = this.props
    const { currentType, error, options } = this.state

    const handleSubmit: SubmitHandler = !!this.props.handleSubmit
      ? this.props.handleSubmit.bind(this, currentType, options)
      : // @ts-expect-error PLEASE_FIX_ME_STRICT_NULL_CHECK_MIGRATION
        defaultHandleSubmit(submitUrls[currentType], csrf, redirectTo)

    return (
      <AuthenticationModal
        blurContainerSelector={blurContainerSelector}
        show={!!currentType}
        onTypeChange={this.openModal}
        onClose={this.closeModal}
        subtitle={this.getSubtitle()}
        type={currentType}
        image={options && options.image}
      >
        {this.state.recaptchaLoaded ? <EnableRecaptcha /> : null}
        <FormSwitcher
          type={currentType}
          error={error}
          handleSubmit={handleSubmit}
          submitUrls={submitUrls}
          options={options}
          handleTypeChange={this.handleTypeChange}
          onSocialAuthEvent={this.props.onSocialAuthEvent}
          showRecaptchaDisclaimer={this.props.showRecaptchaDisclaimer}
        />
      </AuthenticationModal>
    )
  }
}
